import React from "react";
import ActionMenu from "./ActionMenu";
import "../../../Assets/Styles/NetflixList.css"

export const NetfixLicensesColumns = [
    {
        accessorKey: "productName",
        header: "Nom du Produit",
        cell: ({ row }) => <div className="netflix-productName netflix-col-item">{row?.original?.productName || "Aucune donnée"}</div>,
    },
    {
        accessorKey: "status",
        header: "Statut",
        cell: ({ row }) => {
            const statusStyles = {
                available: "netflix-statusAvailable",
                expired: "netflix-statusExpired",
                sold: "netflix-statusSold",
            };
            return (
                <div className="netflix-col-item">
                    <div className={`netflix-status  ${statusStyles[row?.original?.status] || "netflix-statusUndefined"}`}>
                        <span className="netflix-statusText">{row?.original?.status || "Non défini"}</span>
                    </div>
                </div>
            );
        },
    },
    {
        accessorKey: "key",
        header: "Compte Abonnement",
        cell: ({ row }) => (
            <div className="netflix-key" title={row?.original?.key}>
                {row?.original?.key || "Aucun Compte"}
            </div>
        ),
    },
    {
        accessorKey: "expiration",
        header: "Date d'Expiration",
        cell: ({ row }) => {
            const date = row?.original?.expiration
                ? new Date(row.original.expiration).toLocaleDateString()
                : "Non défini";
            return <div className="netflix-date netflix-col-item">{date}</div>;
        },
    },
    {
        accessorKey: "userEmail",
        header: "Email Utilisateur",
        cell: ({ row }) => {
            const emails = row?.original?.userEmail;

            if (!emails || typeof emails !== "string") return <div className="netflix-email">Non défini</div>;

            const cleanedEmails = emails
                .replace(/undefined/g, "")
                .replace(/[\[\]]/g, "")
                .split(",")
                .map(email => email.trim())
                .filter(email => email !== "");

            return (
                <div className="netflix-col-item">
                    {cleanedEmails.map((email, index) => (
                        <div className="netflix-email" key={index}>{email}</div>
                    ))}
                </div>
            );
        },
    },
    {
        accessorKey: "userName",
        header: "Nom Utilisateur",
        cell: ({ row }) => {
            const names = row?.original?.userName;

            if (!names || typeof names !== "string") return <div className="netflix-name">Non défini</div>;

            const cleanedNames = names
                .replace(/undefined/g, "")
                .replace(/[\[\]]/g, "")
                .split(",")
                .map(name => name.trim())
                .filter(name => name !== "");

            return (
                <div className="netflix-col-item">
                    {cleanedNames.map((name, index) => (
                        <div className="netflix-name" key={index}>{name}</div>
                    ))}
                </div>
            );
        },
    },
    {
        accessorKey: "orderNumber",
        header: "Numéro de Commande",
        cell: ({ row }) => {
            const orderNumbers = row?.original?.orderNumber;

            if (!orderNumbers || typeof orderNumbers !== "string") return <div className="netflix-orderNumber">Non défini</div>;

            const cleanedOrderNumbers = orderNumbers
                .replace(/undefined/g, "")
                .replace(/[\[\]]/g, "")
                .split(",")
                .map(order => order.trim())
                .filter(order => order !== "");

            return (
                <div className="netflix-col-item">
                    {cleanedOrderNumbers.map((order, index) => (
                        <div className="netflix-orderNumber" key={index}>{order}</div>
                    ))}
                </div>
            );
        },
    },
    // {
    //     accessorKey: "number",
    //     header: "Quantité Disponible",
    //     cell: ({ row }) => <div className="netflix-quantity">{row?.original?.number || "Non défini"}</div>,
    // },
    {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => <div className="netflix-col-item">
            <ActionMenu row={row} />
        </div>
    }
];
